import React, { lazy, Suspense, useState, useEffect } from "react";
import axios from "axios";
import CacheBuster from "react-cache-buster";
import appversion from "../package.json";
import MediaQuery from "react-responsive";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap/dist/js/bootstrap.min.js";
import "./App.css";
import { CookieSetting } from "cookiesetting-component";
import jsonData from "../src/components/ai-branding.json"; // Import the JSON file
import Navbar from './components/Navbar';
import ThankYou from "./components/ThankYou";
import Loader from "./components/Loader";
import MorganIntro from "./components/MorganIntro";

const Header = lazy(() => import("./components/Header"));
const SocialMedia = lazy(() =>
  import("./components/SocialMedia/SocialMedia.js")
);
const SocialMediaDesk = lazy(() => import("./components/SocialMediaDesk"));
const EventMemories = lazy(() =>
  import("./components/EventMemories/EventMemories.js")
);
const SubscribeForEventNotifications = lazy(() =>
  import("./components/SubscribeForEventNotifications")
);
const EventMemoriesMobile = lazy(() =>
  import("./components/EventMemories/EventMemoriesMobile.js")
);

const SignUpForm = lazy(() => import("./components/SignUpForm"));
const MediaButtons = lazy(() => import("./components/MediaButtons"));
const Footer = lazy(() => import("./components/Footer"));
const Video = lazy(() => import("./components/PavanVideo/Video.js"));

function App() {
  const imgCDNURL = process.env.REACT_APP_POSTNU_CDN_URL;
  const [videoToggle, setVideoToggle] = useState(false);
  const [played, setPlayed] = useState(false);
  const appVersion = appversion.version;
  const handleVideo = (videoToggle) => {
    setVideoToggle(!videoToggle);
    setPlayed(true);
  };

  const [links, setLinks] = useState(null); // Set initial state as null
  
  useEffect(() => {
    const fetchLinks = async () => {
      try {
        const response = await axios.get(process.env.REACT_APP_ANGELAI_JSON);
        setLinks(response.data);
        console.log(response)
      } catch (error) {
        console.error("Error fetching links:", error);
        setLinks(jsonData); // Use local JSON data if fetching fails
      }
    };

    if (!links) {
      fetchLinks(); // Fetch JSON only if the links data is not available
    }
  }, [links]);

  useEffect(() => {
    if (!links) {
      setLinks(jsonData); // Set local JSON data as fallback initially
    }
  }, []);

  return (
    <CacheBuster
          currentVersion={appVersion}
          isEnabled={true} //If false, the library is disabled.
          isVerboseMode={false} //If true, the library writes verbose logs to console.
          metaFileDirectory={"."} //If public assets are hosted somewhere other than root on your server.
        >
          <CookieSetting 
        privacyPolicyLink={process.env.REACT_APP_PRIVACY_POLICY_LINK} 
        configUrl={process.env.REACT_APP_COOKIE_SETTING_JSON}
        analytics={process.env.REACT_APP_ANALYTICS_PATH}
      />

          {links ? (
    <>
      <div className="appBodyContainer">
        <img
          src={imgCDNURL + "desktopbannerbg.webp"}
          className="desktop-bg img-fluid"
          alt="desktop-bg"
        />
        <img
          src={imgCDNURL + "mobilebannerbg.webp"}
          className="mobile-bg img-fluid"
          alt="mobile-bg"
        />
        <img
          src={imgCDNURL + "morganleftshadow.webp"}
          className="moeganshdow  img-fluid"
          alt="flower"
        />
        <img
          src={imgCDNURL + "eventmemoryrightdot.webp"}
          className="eventmemory1rightdot img-fluid"
          alt="flower"
        />
      </div>
      <Navbar />  
      <Suspense fallback={<div />}>
        <Header handleVideo={handleVideo} videoToggle={videoToggle} links={links} />
      </Suspense>
      <MorganIntro links={links}/>

      <MediaQuery minWidth={993}>
        <Suspense fallback={<div />}>
          <EventMemories links={links} />
        </Suspense>
      </MediaQuery>
      {/* Renders the components of mobile and tablet view */}
      <MediaQuery maxWidth={992}>
        <Suspense fallback={<div />}>
          <EventMemoriesMobile links={links}/>
        </Suspense>
      </MediaQuery>

      {/* Renders the components of desktop view */}
      <MediaQuery minWidth={993}>
        <Suspense fallback={<div />}>
          <SocialMediaDesk links={links}/>
        </Suspense>
      </MediaQuery>
      {/* Renders the components of mobile and tablet view */}
      <MediaQuery maxWidth={991}>
        <Suspense fallback={<div />}>
          <SocialMedia links={links}/>
        </Suspense>
      </MediaQuery>
      <Suspense fallback={<div />}>
        <ThankYou links={links}/>
      </Suspense>
      <Suspense fallback={<div />}>
        <SubscribeForEventNotifications links={links}/>
      </Suspense>
      <div className="contactbackground">
        <Suspense fallback={<div />}>
          <SignUpForm links={links}/>
        </Suspense>
      </div>
      <Suspense fallback={<div />}>
        <MediaButtons links={links} />
      </Suspense>
      <Suspense fallback={<div />}>
        <Footer links={links}/>
      </Suspense>
      <Suspense fallback={<Loader />}>
        {played && (
          <Video handleVideo={handleVideo} videoToggle={videoToggle} links={links}/>
        )}
      </Suspense>
    </>
    ) : null}
    </CacheBuster>
  );
}

export default App;
